import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";

export const getAllTicketBooking = createAsyncThunk(
  "Ticket/TicketBookingDetails",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ticket/TicketBookingDetails`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Ticket Booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
